import { Button } from "@/components/ui/button";
import MainContainer from "@/Elements/MainContainer";
import Navbar from "@/Elements/Navbar";
import Arc from "@/lib/Arc";
import { useAuth } from "@/Services/AuthContext";
import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function BookingHistoryScreen() {
	const navigate = useNavigate();
	const { user, isAuthenticated, loading, login, logout } = useAuth();
	const [bookings, setBookings] = useState([]);
	useEffect(() => {
		Arc().read('data', 'reader', [
			"entity=bookings",
			`where=[[guardian_uid,${user.uid}]]`
		]).then(res => setBookings(res.result)).catch(console.error)
	}, [])


	return (
		<>
			<Navbar></Navbar>

			<MainContainer>
				<Button variant="ghost" onClick={() => { navigate('/home') }}>
					<ChevronLeft />
					Back to Home
				</Button>
				<h1 className='text-3xl md:text-4xl lg:text-5xl font-extrabold drop-shadow-lg mt-2'>
					Your Booking History
				</h1>
				<p className='mt-1'>
					True Async PHP is Here! First Alpha Release Unleashes a New Era for High-Performance Apps.
				</p>


				<div className="mt-8 overflow-x-auto">
					{bookings.length > 0 ? (
						<table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
							<thead>
								<tr className="bg-gray-100 border-b border-gray-200">
									<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Booking ID</th>
									<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
									<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Time Slot</th>
									<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Children</th>
									<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
									<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
									{/* <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment</th> */}
								</tr>
							</thead>
							<tbody className="divide-y divide-gray-200">
								{bookings.map((booking) => (
									<tr key={booking.id} className="hover:bg-gray-50">
										<td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{booking.id}</td>
										<td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{new Date(booking.booking_date).toLocaleDateString()}</td>
										<td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{booking.time_slot_start} - {booking.time_slot_end}</td>
										<td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{booking.number_of_children || 'N/A'}</td>
										<td className="px-4 py-4 whitespace-nowrap">
											<span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${booking.booking_status === 'Confirmed' ? 'bg-green-100 text-green-800' :
												booking.booking_status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
													'bg-red-100 text-red-800'
												}`}>
												{booking.booking_status}
											</span>
										</td>
										<td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">₹{booking.amount_paid || '0'}</td>
										{/* <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-600">{booking.payment_status} ({booking.payment_method})</td> */}
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<p className="text-center text-gray-500 mt-4">No bookings found.</p>
					)}
				</div>
			</MainContainer>
		</>
	);
}
export default BookingHistoryScreen;